import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Pagination, Row} from 'react-bootstrap';
import {Formik} from 'formik';
import Select from 'components/Form/Select';
import {
    DEFAULT_CUSTOMER_OPTION,
    DEFAULT_LOCATION_OPTION,
    DEFAULT_ROLE_OPTION,
    DEFAULT_SITE_OPTION
} from 'constants/uiConstants';
import {getCustomerOptions, getLocationOptions, getRoleOptions, getSiteOptions} from 'utils/Ui';

const filterStyle = {display: 'inline-block', marginRight: 10};

export default function UsersFilters({useCustomer, useSite, useLocation, customers, sites, locations, isLoading, setFilters}) {
    const isMounted = useRef(false);
    const [roleOptions, setRoleOptions] = useState([DEFAULT_ROLE_OPTION]);
    const [customerOptions, setCustomerOptions] = useState([DEFAULT_CUSTOMER_OPTION]);
    const [siteOptions, setSiteOptions] = useState([DEFAULT_SITE_OPTION]);
    const [locationOptions, setLocationOptions] = useState([DEFAULT_LOCATION_OPTION]);
    const [page, setPage] = useState(1);
    const initialValues = {
        role: '',
        customer_uuid: '',
        site_uuid: '',
        location_uuid: '',
    };

    useEffect(() => {
        isMounted.current = true;
        setRoleOptions(getRoleOptions(true));
        return () => isMounted.current = false;
    }, []);

    const handlePageClick = direction => {
        setFilters(prevFilters => {
            let page = prevFilters.offset / prevFilters.limit + 1;
            if (direction === 'forward') page += 1;
            else page -= 1;
            setPage(page);
            const offset = (page - 1) * prevFilters.limit;
            return {...prevFilters, offset: offset};
        });
    };

    const form = (
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={() => {}}
        >
            {({handleChange, setFieldValue}) => {

                useEffect(() => {
                    let options;
                    if (useCustomer) setCustomerOptions(getCustomerOptions(customers));
                    if (useSite) {
                        options = getSiteOptions(
                            sites, useCustomer, initialValues.customer_uuid,
                            false, setFieldValue
                        );
                        setSiteOptions(options);
                    }
                    if (useLocation) {
                        options = getLocationOptions(
                            locations, useSite, initialValues.site_uuid,
                            false, setFieldValue
                        );
                        setLocationOptions(options);
                    }
                }, [customers, sites, locations]);

                const handleInputChange = e => {
                    handleChange(e);
                    const filtersToRemove = [];
                    const filterName = e.target.name;
                    let filterValue = e.target.value;
                    if (filterName === 'role') filterValue = Number(filterValue) || null;
                    if (filterName === 'customer_uuid') {
                        setSiteOptions(getSiteOptions(sites, useCustomer, filterValue, true, setFieldValue));
                        setLocationOptions(getLocationOptions(locations, useSite, '', true, setFieldValue));
                        filtersToRemove.push('site_uuid');
                        filtersToRemove.push('location_uuid');
                    }
                    else if (filterName === 'site_uuid') {
                        setLocationOptions(getLocationOptions(locations, useSite, filterValue, true, setFieldValue));
                        filtersToRemove.push('location_uuid');
                    }
                    setFilters(prevFilters => {
                        setPage(1);
                        const newFilters = {...prevFilters, offset: 0};
                        if (filterValue) newFilters[filterName] = filterValue;
                        else delete newFilters[filterName];
                        filtersToRemove.forEach(filter => delete newFilters[filter]);
                        return newFilters;
                    });
                };

                return (
                    <Form>
                        <div style={filterStyle}>
                            <Select
                              label="Role" name="role" options={roleOptions} skipgroup="true"
                              onChange={handleInputChange} disabled={isLoading}
                            />
                        </div>
                        {useCustomer &&
                            <div style={filterStyle}>
                                <Select
                                  label="Customer" name="customer_uuid" options={customerOptions} skipgroup="true"
                                  onChange={handleInputChange} disabled={isLoading}
                                />
                            </div>}
                        {useSite &&
                            <div style={filterStyle}>
                                <Select
                                  label="Site" name="site_uuid" options={siteOptions} skipgroup="true"
                                  onChange={handleInputChange} disabled={isLoading}
                                />
                            </div>}
                        {useLocation &&
                            <div style={filterStyle}>
                                <Select
                                  label="Location" name="location_uuid" options={locationOptions} skipgroup="true"
                                  onChange={handleInputChange} disabled={isLoading}
                                />
                            </div>}
                    </Form>
                );
            }}
        </Formik>
    );

    return (
        <Row>
            <Col md="8">
                {form}
            </Col>
            <Col md="4">
                <Pagination className="pagination-sm ac-pagination">
                    <Pagination.Prev className="ac-page-link" onClick={() => handlePageClick('backward')} disabled={page<2} />
                    <Pagination.Item className="ac-page-item" active>{page}</Pagination.Item>
                    <Pagination.Next className="ac-page-link" onClick={() => handlePageClick('forward')} />
                </Pagination>
            </Col>
        </Row>
    );
}
